import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('ErrorPrivate').create(({ theme }) => ({
  backdrop: {
    width: '100vw',
    minHeight: '120vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    zIndex: 99,
  },

  settings: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },

  iconAndTitleWrapper: {
    display: 'flex',
    alignItems: 'center',
    textTransform: 'uppercase',
    fontSize: '13px',
    lineHeight: theme.sizes.texts.lineHeight.s,

    color: theme.colors.text.secondary,
    gap: '6px',
  },

  largeSettingsContainer: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    padding: '10px 16px',
    background: '#272729',
    border: '1px solid',
    borderColor: '#2B2B2C',
    borderRadius: '16px',
    justifyContent: 'space-between',
  },

  tinySettingsWrapper: {
    width: '100%',
    display: 'grid',
    gap: '8px',
    gridTemplateColumns: '0.5fr 0.5fr',
  },

  settingContainer: {
    display: 'flex',
    alignItems: 'center',
    padding: '10px 16px',
    background: '#272729',
    border: '1px solid',
    borderColor: '#2B2B2C',
    borderRadius: '16px',

    textTransform: 'uppercase',
    fontWeight: '370',
    fontSize: '13px',
    lineHeight: theme.sizes.texts.lineHeight.s,

    color: theme.colors.text.secondary,
    gap: '6px',
  },

  doubleConnectionRoot: {
    width: '100vw',
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    background: 'black',
  },

  doubleConnectionBG: {
    width: '100%',
    height: '100%',

    maxHeight: '340px',
    maxWidth: '420px',
    zIndex: 4,
    filter: 'grayscale(100%) blur(6px)',
  },

  farcanaBg: {
    left: '10%',
    width: '100%',
    filter: 'blur(50px)',
    position: 'relative',
    top: '-140px',
    alignSelf: 'center',
    zIndex: 4,
  },

  heading: {
    fontSize: theme.sizes.texts.fontSize.l,
    fontWeight: 450,
    lineHeight: theme.sizes.texts.lineHeight.xl,

    color: theme.colors.text.primary,
  },

  description: {
    fontSize: theme.sizes.texts.fontSize.s,
    lineHeight: theme.sizes.texts.lineHeight.m,

    fontWeight: 350,
    color: theme.colors.text.secondary,
    textAlign: 'center',
  },

  headingAndSteamWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
  },

  descriptionWrapper: {},

  doubleConnectionContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '12px',
    borderRadius: '12px',
    padding: '20px',
    width: '92.5%',
    height: '252px',
    position: 'absolute',
    bottom: '12px',
    zIndex: 5,
    backgroundColor: 'rgb(21, 21, 22)',
  },

  doubleConnectionButtonsWrapper: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },

  mikeImg: {
    width: '100%',
    zIndex: 5,
    bottom: '200px',
    position: 'absolute',
  },
  egsImg: {
    width: '100%',
    zIndex: 5,
    top: '0px',
    position: 'absolute',
  },

  connectAnotherButton: {
    height: '52px',
    width: '100%',
    fontWeight: 460,
    fontSize: theme.sizes.texts.fontSize.m,
    lineHeight: theme.sizes.texts.lineHeight.xl,
  },

  continueWithoutButton: {
    height: '40px',
    fontWeight: 370,
    fontSize: '13px',
    lineHeight: theme.sizes.texts.lineHeight.s,

    width: '100%',
    boxShadow: 'none',
    textTransform: 'uppercase',
    background: 'transparent',
    color: theme.colors.text.secondary,
  },

  doubleConnectionBackdrop: {
    position: 'absolute',
    width: '100vw',
    height: '100vh',
    zIndex: 3,
    backgroundColor: 'black',
  },
}))
